import { Button, Typography } from "@mui/material";
import WhatshotIcon from "@mui/icons-material/Whatshot";

export default function Summary() {
    return (
        <div className="Summary">
            <Typography variant="h2">
                Rapid Detection of Bacterial Infection using <b>RamanNet</b>
            </Typography>
            <Typography variant="h6">
                Upload your Raman spectroscopy results here for Bacterial
                Infection Detection using our State-of-the-Art Machine Learning Model
            </Typography>
            <br></br>
            <div className="ActionButtons">
                <Button
                    sx={{ borderRadius: "1.5rem" }}
                    href="#raman_net"
                    size="large"
                    variant="contained"
                >
                    Try it Now
                </Button>
                <Button
                    sx={{ borderRadius: "1.5rem" }}
                    href="#how_it_works"
                    size="large"
                    color="secondary"
                    variant="outlined"
                    startIcon={<WhatshotIcon />}
                >
                    How it Works
                </Button>
            </div>
        </div>
    );
}
